module.exports = __webpack_public_path__ + "img/logo.84153a46.png";